/**
 * The forecast horizon in words.
 *
 * The stored value is a code ('4h', '1d', '180d'), and every page that names a
 * forecast has to read it out. Shared rather than copied so the two do not
 * drift — a horizon that reads "4 hours" on one page and "4h" on another is the
 * kind of difference nobody notices until it is everywhere.
 *
 * Falls back to prediction_window_days for rows written before timeframe was
 * stored, and to the raw code if neither resolves — an unfamiliar label beats
 * none.
 *
 * The fallback is checked after the code, not before: sub-day horizons store
 * prediction_window_days as Math.round(hours / 24), which is 0 for 4h, so
 * trusting it first would lose the horizon on exactly the rows that have one.
 */
const formatHorizon = (tf, windowDays) => {
  const code = String(tf || '').toLowerCase();
  const named = {
    '1h': '1 hour', '4h': '4 hours',
    '1d': '1 day', '2d': '2 days', '7d': '7 days',
    '30d': '30 days', '90d': '90 days', '180d': '180 days',
  };
  if (named[code]) return named[code];
  const hourMatch = code.match(/^(\d+)h$/);
  if (hourMatch) return `${hourMatch[1]} hour${hourMatch[1] === '1' ? '' : 's'}`;
  const dayMatch = code.match(/^(\d+)d$/);
  if (dayMatch) return `${dayMatch[1]} day${dayMatch[1] === '1' ? '' : 's'}`;
  const days = Number(windowDays);
  if (Number.isFinite(days) && days > 0) return `${days} day${days === 1 ? '' : 's'}`;
  return code || null;
};

export default formatHorizon;
